import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import './style/base.css'
import { createApp } from 'vue'
import ContextMenu from '@imengyu/vue3-context-menu'
import App from './App.vue'
import router from './router/index.js'
import vuexStore from './vuexStore/config.js'
import './style.css'
import "vue-multiselect/dist/vue-multiselect.min.css"
import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css'
import CSRFPlugin from './plugins/csrf.js'
import axios from 'axios';
import { setupCSRFInterceptor } from './utils/csrf.js';

// Configuration globale d'axios pour inclure les cookies
axios.defaults.withCredentials = true;
// Configuration de la base URL
// axios.defaults.baseURL = 'http://127.0.0.1:8000';
// Configuration de l'intercepteur CSRF
setupCSRFInterceptor(axios);

const app = createApp(App)
app.use(vuexStore)
app.use(router)
app.use(ContextMenu)
app.use(VueTippy, {theme: 'light'})
app.use(CSRFPlugin)
app.mount('#app')